import { Component, Input, OnInit } from "@angular/core";
import { OneTimePaymentRequest, OneTimePaymentResponse, WebCompany, WebCustomer } from "../../../../../models";
import { MatDialogRef } from "@angular/material/dialog";
import { CompanyService, CustomerService } from "../../../../../services";
import { Subscription } from "rxjs";
import { filter } from "rxjs/operators";

@Component({
  selector: "app-print-payment-receipt",
  templateUrl: "./print-payment-receipt.component.html",
  styleUrls: ["./print-payment-receipt.component.scss"]
})
export class PrintPaymentReceiptComponent implements OnInit
{

  @Input() paymentInfo: OneTimePaymentRequest;
  @Input() otpResponse: OneTimePaymentResponse[];

  public customer: WebCustomer;
  public customerSubscription: Subscription;
  public company: WebCompany;

  public totalAmount: number;
  public fees: number;


  public date: string;

  constructor(
    public dialogRef: MatDialogRef<PrintPaymentReceiptComponent>,
    public customerService: CustomerService,
    public companyService: CompanyService
  ) { }

  ngOnInit(): void
  {

    this.date = new Date().toLocaleDateString();

    this.totalAmount = this.paymentInfo.ContractAmount + this.paymentInfo.BudgetAmount + this.paymentInfo.AccountAmount + this.paymentInfo.APSPayment.ConvenienceFee + this.paymentInfo.APSPayment.ConvenienceFeeTax;
    this.fees = (this.paymentInfo.APSPayment.ConvenienceFee == null ? 0 : this.paymentInfo.APSPayment.ConvenienceFee) + (this.paymentInfo.APSPayment.ConvenienceFeeTax == null ? 0 : this.paymentInfo.APSPayment.ConvenienceFeeTax)
    this.customerSubscription = this.customerService.customer
      .pipe(filter(customer => !!customer))
      .subscribe(customer =>
      {
        this.customer = customer;
      });

    this.companyService.company.subscribe(company =>
    {
      this.company = company;
    });
  }

  printReceipt()
  {

    window.print();

  }
  public handleClose(): void
  {
    this.dialogRef.close();
  }

  ngOnDestroy(): void 
  {
    this.customerSubscription.unsubscribe();
  }
}
